var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.printContract).length)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.print_contract}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }